const ONBOARDING_KEY = 'qnaread.onboardingDone';

export function markOnboardingCompleteLocally() {
  try {
    localStorage.setItem(ONBOARDING_KEY, '1');
  } catch {
    /* ignore */
  }
}

/** After sign-in, restore local onboarding skip from server profile (logout clears local flag). */
export async function syncOnboardingFlagFromServer(apiClient) {
  try {
    const res = await apiClient.get('/api/users/me/learning-profile');
    if (res.data?.onboardingCompleted) {
      markOnboardingCompleteLocally();
    }
  } catch {
    /* gate will retry */
  }
}
